import * as React from 'react';
import AppTabs from '../../components/AppTabs';
import { useTranslations } from '../../store/translations/hooks';
import { TK } from '../../store/translations/translationKeys';
import TitledContainer from '../../components/TitledContainer';
import { Tabs, Tab } from '@material-ui/core';
import { useHistory, useLocation } from 'react-router-dom';
import MySubscription from '../MySubscription';
import Users from '../Users';
import { AdministratorDashboard } from '../AdministratorDashboard';
import { FeatureEnum } from '../../models';
import Breadcrumbs from '../../components/Breadcrumbs';
import { paths } from '../../app/constants';

type AccountTab = 'subscription' | 'users' | 'admin';

const Account: React.FC = () => {
    const t = useTranslations();
    const history = useHistory();
    const location = useLocation();

    const queryParams = new URLSearchParams(location.search);
    const tabFromUrl = queryParams.get('tab') as AccountTab | null;
    const validTabs: AccountTab[] = ['subscription', 'users', 'admin'];
    const tab: AccountTab = tabFromUrl && validTabs.includes(tabFromUrl) ? tabFromUrl : 'subscription';

    const setTab = (newTab: AccountTab) => {
        const params = new URLSearchParams(location.search);
        params.set('tab', newTab);
        history.push({ search: params.toString() });
    };

    return (
        <>
        <Breadcrumbs items={[
            { label: t(TK.settings), active: false, onClick: () => history.push(paths.settings()) },
            { label: t(TK.settingsCategoryGeneral), active: false },
            { label: t(TK.accountAndSubscription), active: true }
        ]} />
        <TitledContainer id='account' title={t(TK.accountAndSubscription)}>
            <AppTabs value={tab} onChange={(_, v) => setTab(v)} indicatorColor="primary" textColor="primary" style={{ borderBottom: 'var(--border-thin) solid var(--appLigthGrey)' }}>
                <Tab label={t(TK.mySubscription)} value="subscription" />
                <Tab label={t(TK.admin)} value="admin" />
            </AppTabs>
            <div className='adminTabsContent'>
                {tab === 'subscription' && <MySubscription />}
                {tab === 'admin' && <AdministratorDashboard />}
            </div>
        </TitledContainer>
        </>
    );
};

export default Account;
